package com.upcominds.expedite.dto

import kotlinx.serialization.Serializable

@Serializable
data class CommunityUpdateRequest(
    val name: String,
    val description: String?,
    val imageUrl: String?,
    val area: String?,
    val latitude: Double?,
    val longitude: Double?
)
